import { useEffect, useState } from "react";
import { t } from "i18next";
import { Modal, ModalBody } from "reactstrap";

import ButtonTextLoader from "../../components/Loaders/ButtonTextLoader";
import { ColoredButton, WhiteButton } from "../../styledComponents/buttons";
import { CommonText, CardTitle} from "../../styledComponents/common";
import { ModalButtonSection } from "../../styledComponents/members";

const TaskArchiveModal = ({
  isOpen,
  toggle,
  handleSave,
  isLoading,
  location,
}) => {

  return (
    <Modal isOpen={isOpen} toggle={toggle} style={{ marginTop: `25vh` }}>
      <ModalBody style={{ padding: `20px` }}>
       <CommonText name margin="20px 0 auto 0">
        {
          location.is_active ?
          t("task_archive_warning") :
          t("task_unarchive_warning")
        }
       </CommonText>
       <CardTitle style={{ paddingLeft: `15px`, marginTop: `30px` }}>
        {location.name}
       </CardTitle>
        <ModalButtonSection>
          <WhiteButton type="cancel" onClick={toggle}>
            {t("cancel")}
          </WhiteButton>
          <ColoredButton
            type="blue"
            padding={isLoading ? "0 15px" : "0 30px"}
            onClick={() => handleSave(location.id)}
          >
            {isLoading ? (
              <ButtonTextLoader loadingText={t("yes")} fontSize="13px" />
            ) : (
              t("yes")
            )}
          </ColoredButton>
        </ModalButtonSection>
      </ModalBody>
    </Modal>
  );
};

export default TaskArchiveModal;
